<template>
  <b-modal
    :title="title"
    ref="modal"
    scrollable
    centered
    ok-only
    class="text-left"
  >
    <slot></slot>
  </b-modal>
</template>

<script>
import { modalBaseMixin } from "../../mixins/modalBase";

export default {
  name: "ModalBase",
  mixins: [modalBaseMixin],
  props: {
    title: String
  }
};
</script>

<style scoped></style>
